<template>
  <div>

<!--    <img src="../assets/Banner02.jpg" class="img-fluid w-100" alt="banner02">-->
    <!-- Job Single Content Starts -->
<!--    <section class="job-single-content section-padding4">-->
<!--&lt;!&ndash;      <button type="button" class="btn btn-lg btn-danger" data-toggle="popover" title="Popover title" data-content="And here's some amazing content. It's very engaging. Right?">Click to toggle popover</button>&ndash;&gt;-->

<!--      <div class="container">-->

<!--        &lt;!&ndash;面包屑导航&ndash;&gt;-->
<!--        <nav aria-label="breadcrumb" class="nav">-->
<!--          <ol class="breadcrumb">-->
<!--            <li class="breadcrumb-item"><a href="#" onclick=""><span>首页</span></a></li>-->
<!--&lt;!&ndash;            <li class="breadcrumb-item"><a href="javascript:void(0);" onclick=""><span>产品展示</span></a></li>&ndash;&gt;-->
<!--            <li class="breadcrumb-item"><router-link :to="{name:'products',query:{parentId:'', s:Math.random()}}">产品展示</router-link></li>-->
<!--            <li class="breadcrumb-item active" aria-current="page"-->
<!--                v-if="productList!= undefined && productList != null && productList != '' &&-->
<!--                      productList[0].parentName != undefined && productList[0].parentName != null && productList[0].parentName != ''">-->
<!--              <span>{{productList[0].parentName}}</span>-->
<!--            </li>-->
<!--            <li class="breadcrumb-item active" aria-current="page" v-else>-->
<!--              <span>所有产品</span>-->
<!--            </li>-->
<!--          </ol>-->
<!--        </nav>-->

<!--      </div>-->
<!--    </section>-->

    <img src="../assets/probanner.jpg" class="img-fluid w-100" alt="banner02">
    <section class="feature-area">
      <div class="mbx">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="nytit pull-left">产品展示</div>
            </div>
            <div class="col-lg-3">
              <div class="mbxwrap">
                <router-link to="/" class="underline">首页</router-link> <span>/</span>
                <router-link to="/products" class="underline">产品展示</router-link> <span>/</span>
                <em>产品详细</em>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>



    <!--产品简介-->
    <section class="feature-area section-padding6" style="border-bottom: 3px solid #efefef">
      <div class="container">
        <div>
          <div class="row">
            <div class="col-lg-12 goods-image">
              <div style="width: 25rem;height: 20rem; border: 1px solid #eee" class="middle col-lg-5" ref="target">
<!--                <img class="product-image" :src="product.path"  alt=""/>-->
                <img class="product-image" :src="productDetails.images.split(';')[0]"  alt=""/>
                <!-- 遮罩色块 -->
                <div v-show="show" class="layer" :style="layerPosition"></div>
              </div>
              <div v-show="show" class="larger" :style="[{backgroundImage:`url(`+productDetails.images+`)`}, largePosition]"></div>
              <div class="col-lg-7">
                <h1>{{product.name}}</h1>
                <p style="font-size: 1.3rem;padding-top: 30px;">
                  {{product.decr}}
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>

    <!--产品特点-->
    <section class="jobs-area section-padding3 paddingtop30" style="border-bottom: 3px solid #efefef" v-if="feture_list != undefined && feture_list != null && feture_list != ''">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="jobs-title">
              <h2>产品介绍</h2>
            </div>
          </div>
          <div class="col-lg-12 paddingtop30" v-for="(list,index) in feture_list">
            <div class="card">
              <div class="card-header" style="background-color: #4794da; color: white !important;">
                <div>{{list.name}}</div>
              </div>

              <div class="card-body">
                <p white-space="pre-wrap" v-for="(subList, subIndex) in list.values">{{subList}}</p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>

<!--    <div id="content">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-sm-9" v-for="(list,index) in feture_list">-->

<!--&lt;!&ndash;            <h2 class="mbottom30">Blockquotes</h2>&ndash;&gt;-->
<!--&lt;!&ndash;            <p class="gray mbottom30">Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p>&ndash;&gt;-->
<!--            <div class="blockquote1 mbottom30">-->
<!--              <blockquote>{{list.paramEntity.name}}</blockquote>-->
<!--            </div>-->
<!--            <p class="gray mbottom30" v-for="(subList, subIndex) in list.paramValueEntityList">{{subList.value}}</p>-->

<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>&lt;!&ndash; end content &ndash;&gt;-->

    <!--产品型号与产品技术参数-->
    <section class="jobs-area section-padding3 section-padding6" v-if="param_list != undefined && param_list != null && param_list != ''">
      <div class="container"  style="overflow-x: auto">
        <div class="row paddingbottom30">
          <div class="col-lg-12">
            <div class="jobs-title">
              <h2>产品技术参数</h2>
            </div>
          </div>
        </div>
        <table id="tab01" class="table">
          <thead class="thead-dark" >
          <tr>
            <th scope="col" v-for="(list, index) in param_list[0].excelColumnList" :colspan="list.columnSpan">{{list.columnValue}}</th>
          </tr>
          </thead>
          <tbody>
          <tr :class="{rowcolor:index%2==0}" v-for="(list, index) in param_list" v-if="index > 0">
            <td white-space="pre-wrap" v-for="(col, colIndex) in list.excelColumnList"
                :colspan="col.columnSpan">{{col.columnValue}}</td>
          </tr>
          </tbody>
        </table>

        <table id="tab02" class="table" v-if="param_list_2 != undefined && param_list_2 != null && param_list_2 != ''">
          <thead class="thead-dark" >
          <tr>
            <th scope="col" v-for="(list, index) in param_list_2[0].excelColumnList" :colspan="list.columnSpan">{{list.columnValue}}</th>
          </tr>
          </thead>
          <tbody>
          <tr :class="{rowcolor:index%2==0}" v-for="(list, index) in param_list_2" v-if="index > 0">
            <td white-space="pre-wrap" v-for="(col, colIndex) in list.excelColumnList"
                :colspan="col.columnSpan">{{col.columnValue}}</td>
          </tr>
          </tbody>
        </table>
      </div>


    </section>


    <!--器皿配置表-->
    <section class="jobs-area section-padding3 section-padding6" v-if="param_list_3 != undefined && param_list_3 != null && param_list_3 != ''">
      <div class="container"  style="overflow-x: auto">
        <div class="row paddingbottom30">
          <div class="col-lg-12">
            <div class="jobs-title">
              <h2>器皿配置表</h2>
            </div>
          </div>
        </div>
        <table class="table">
          <thead class="thead-dark" >
          <tr>
            <th scope="col" v-for="(list, index) in param_list_3[0].excelColumnList" :colspan="list.columnSpan">{{list.columnValue}}</th>
          </tr>
          </thead>
          <tbody>
          <tr :class="{rowcolor:index%2==0}" v-for="(list, index) in param_list_3" v-if="index > 0">
            <td white-space="pre-wrap" v-for="(col, colIndex) in list.excelColumnList"
                :colspan="col.columnSpan">{{col.columnValue}}</td>
          </tr>
          </tbody>
        </table>

      </div>

    </section>


  </div>


</template>

<script>
import { reactive, ref, watch } from 'vue'
import { useMouseInElement } from '@vueuse/core'
  export default {
    props: {
      images: {
        type: Array,
        default: () => []
      }
    },
    setup (props) {
      const currIndex = ref(0)

      // 1. 是否显示遮罩和大图
      const show = ref(false)

      // 2. 遮罩的坐标(样式)
      const layerPosition = reactive({
        top: 0,
        left: 0
      })

      // 3. 大图的背景坐标(样式)
      const largePosition = reactive({
        backgroundPositionX: 0,
        backgroundPositionY: 0
      })

      // 4. 获取监听元素的实例对象, 使用useMouseInElement函数进行获取坐标
      const target = ref(null)
      const { elementX, elementY, isOutside } = useMouseInElement(target)

      // 5. 监听元素坐标值的变化
      watch([elementX, elementY, isOutside], () => {
        show.value = !isOutside.value
        const position = { X: 0, Y: 0 }

        if (elementX.value < 100) position.X = 0
        else if (elementX.value > 300) position.X = 200
        else position.X = elementX.value - 100

        if (elementY.value < 100) position.Y = 0
        else if (elementY.value > 220) position.Y = 120
        else position.Y = elementY.value - 100

        layerPosition.left = position.X + 'px'
        layerPosition.top = position.Y + 'px'
        largePosition.backgroundPositionX = -2 * position.X + 'px'
        largePosition.backgroundPositionY = -4 * position.Y + 'px'
      })

      return { currIndex, show, layerPosition, largePosition, target }
    },
    data(){
      return{
        navLists: JSON.parse(this.$_storage.getLocalStore("navLists")),
        productList: [],
        productDetails: Object,
        product : JSON.parse(this.$_storage.getLocalStore("product")),
        param: [],
        param_list: [],
        param_list_2: [],
        param_list_3: [],
        feture_list: [],
        colsize: 0,

      }
    },
    methods: {
      getProductDetails() {
        const vm = this;
        console.log(this.$route.query.parentId)
        console.log(222)
        vm.$_axios({
          method: 'post',
          url: '/mapis/product/getProductDetails',
          params: {
            productId: vm.product.id
          },
          needLogin: false,
        }).then((response) => {
          if (response.status === 200) {
            const responseData = response.data.data;

            vm.productDetails = responseData;
            console.log(vm.productDetails.images);
            vm.param_list = responseData.paramList;
            vm.param_list_2 = responseData.paramList2;
            vm.param_list_3 = responseData.paramList3;
            vm.feture_list = responseData.fetureList;
          }
        });
      },

    },
    created() {
      let vm = this;
    },
    mounted() {
      let vm = this;
      vm.getProductDetails();
    }
  };

</script>


<style scoped lang="less">
.goods-image {
  width: 100%;
  height: 480px;
  position: relative;
  display: flex;
  z-index: 500;
  .larger {
    position: absolute;
    top: 0;
    left: 600px;
    width: 480px;
    height: 384px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    background-repeat: no-repeat;
    background-size: 800px 800px;
    background-color: #f8f8f8;
    z-index:9999
  }
  .middle {
    width: 400px;
    height: 320px;
    background: #f5f5f5;
    position: relative;
    cursor: move;
    .layer {
      width: 200px;
      height: 200px;
      background: rgba(0,0,0,.2);
      left: 0;
      top: 0;
      position: absolute;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ProductDetails.vue?69f074a9